import { render, staticRenderFns } from "./ForwardConfirmation.vue?vue&type=template&id=04e60068&scoped=true&"
import script from "./ForwardConfirmation.vue?vue&type=script&lang=js&"
export * from "./ForwardConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e60068",
  null
  
)

export default component.exports